import { c as _c } from "react/compiler-runtime";
import { SeoHeader } from '@/components/SeoHeader';
import { ContentContainer, Layout } from '@/components/layout';
import React, { type PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchFormValues } from './hooks/useFormSearch';
import PageHeadline from '@/components/PageHeadline';
import Search from './Search';
import { type Category } from './functions/getCategories';
import { SectionDelimiter } from '@/components/SectionDelimiter';
import { Rewards } from './Rewards';
import { MoreInfo } from './MoreInfo';
import { Recommendations } from './Recommendations';
import { type EshopBox } from '@/components/boxes/EshopBox/types';
import { useCoupon } from './hooks/useCoupon';
import { CouponModal } from './CouponModal';
import { FormApi } from 'final-form';
import { PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
interface Props {
  categories: Category[];
  eshops: EshopBox[];
  formValues: Partial<SearchFormValues>;
  sync: (values: Partial<SearchFormValues>) => void;
  searchForm: FormApi<SearchFormValues, Partial<SearchFormValues>>;
  menuPromoBanners?: PageMenuPromoBanner[];
}
export function DiscountsLayout(props) {
  const $ = _c(43);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["core", "discounts"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    children,
    menuPromoBanners
  } = props;
  const {
    isVisible,
    coupon,
    setIsVisible
  } = useCoupon();
  let t1;
  if ($[1] !== t) {
    t1 = t("discounts:seo.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("discounts:seo.description");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <SeoHeader title={t1} description={t2} />;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== coupon || $[9] !== isVisible || $[10] !== setIsVisible) {
    t4 = <CouponModal isVisible={isVisible} setIsVisible={setIsVisible} coupon={coupon} />;
    $[8] = coupon;
    $[9] = isVisible;
    $[10] = setIsVisible;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="bgCircle absolute top-0 right-0 h-[25rem] w-[25rem] translate-x-[40%] -translate-y-1/2 rotate-180 md:h-[55.25rem] md:w-[55.25rem] md:translate-x-[54%] md:-translate-y-[40%] md:rotate-[195deg]" />;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t("discounts:title");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <div className="bg-blue-100 px-4 pt-32 md:pt-64 md:pb-12">{t5}<PageHeadline className="md:mx-auto md:max-w-292" id="title" text={t6} width="full" /></div>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== props.categories || $[18] !== props.formValues || $[19] !== props.searchForm || $[20] !== props.sync) {
    t8 = <Search categories={props.categories} initialValues={props.formValues} onSearch={props.sync} searchForm={props.searchForm} />;
    $[17] = props.categories;
    $[18] = props.formValues;
    $[19] = props.searchForm;
    $[20] = props.sync;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== props.eshops) {
    t9 = <Recommendations eshops={props.eshops} />;
    $[22] = props.eshops;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== children || $[25] !== t8 || $[26] !== t9) {
    t10 = <ContentContainer className="mt-12 px-4 pb-20 md:mt-4 md:px-0 lg:pb-40">{t8}{children}{t9}</ContentContainer>;
    $[24] = children;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="bgCircle absolute bottom-0 left-0 -translate-x-1/2 -translate-y-1/4" />;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t10 || $[30] !== t7) {
    t12 = <div className="relative overflow-hidden bg-blue-100">{t7}{t10}{t11}</div>;
    $[29] = t10;
    $[30] = t7;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <SectionDelimiter color="bg-blue-50" background="bg-blue-100" />;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Rewards />;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  let t16;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="bg-blue-50 pt-14 md:pt-20">{t14}<ContentContainer className="mt-12 px-4 pb-6 md:mt-4 md:px-0 md:pt-20"><MoreInfo /></ContentContainer></div>;
    t16 = <div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" />;
    $[34] = t15;
    $[35] = t16;
  } else {
    t15 = $[34];
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t12) {
    t17 = <div className="relative overflow-hidden">{t12}{t13}{t15}{t16}</div>;
    $[36] = t12;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== menuPromoBanners || $[39] !== t17 || $[40] !== t3 || $[41] !== t4) {
    t18 = <Layout menuPromoBanners={menuPromoBanners}>{t3}{t4}{t17}</Layout>;
    $[38] = menuPromoBanners;
    $[39] = t17;
    $[40] = t3;
    $[41] = t4;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  return t18;
}